import { FC } from 'react';
import { PopoverMenuItems } from '@frontend/task-center-components';
import { PopoverMenu, Text, usePopoverMenu } from '@frontend/design-system';
import { TaskFormRow } from '../../common';

type LocationData = { id: string; name?: string };

interface LocationPickerProps {
  data: Array<LocationData>;
  label: string;
  placeholder: string;
  value: string;
  onSelect: (value: string) => void;
  isEditing?: boolean;
  isRemovable?: boolean;
  touched?: boolean;
  error?: string;
  trackingIds?: {
    removeButton?: string;
    chipButton?: string;
  };
}

export const LocationPicker: FC<LocationPickerProps> = ({
  data,
  label,
  placeholder,
  value,
  onSelect,
  trackingIds,
  isEditing = false,
  isRemovable = true,
  touched = false,
  error = '',
}) => {
  let children;

  const { getItemProps, getMenuProps, getTriggerProps, close } = usePopoverMenu({ placement: 'bottom-start' });

  const dataValue = data.find((item) => item.id === value)?.name ?? '';

  const onClickItem = (item: LocationData) => {
    onSelect(item.id);
    close();
  };

  if (data.length >= 1) {
    children = (
      <PopoverMenu {...getMenuProps()}>
        <PopoverMenuItems<LocationData>
          data={data}
          getItemProps={getItemProps}
          renderItem={(item) => <Text>{item.name}</Text>}
          keyGen={(item) => `location-picker-${item.id}`}
          onClickItem={onClickItem}
        />
      </PopoverMenu>
    );
  }

  return (
    <TaskFormRow
      label={label}
      icon='locations'
      placeholder={placeholder}
      buttonIconName='location'
      value={dataValue}
      getTriggerProps={getTriggerProps}
      disabled={isEditing || data.length === 1}
      trackingIds={trackingIds}
      isEditing={isEditing}
      isRemovable={isRemovable}
      error={touched ? error : ''}
    >
      {!isEditing && children}
    </TaskFormRow>
  );
};
